import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { get as _get } from 'lodash';
import allContests from '../../containers/routes/ContestLanding/allContests';
import contestPropType from '../../propTypes/contest';
import config from '../../config';

const ContestNav = ({ contest, period, region, showLogo }) => (
  <div className="sl-contest-nav">
    <ul className="sl-contest-nav__menu">
      <li>
        <Link to={`/${config.baseContestUrl(region, period)}entries`}>Entries</Link>
      </li>
      <li>
        <Link to={`/${config.baseContestUrl(region, period)}details`}>Details</Link>
      </li>
      <li>
        <Link to={`/${config.baseContestUrl(region, period)}submit`}>Submit</Link>
      </li>
      {contest && contest.meta && contest.meta.acf && contest.meta.acf.vote_url ? (
        <li>
          <a href={contest.meta.acf.vote_url}>Vote</a>
        </li>
      ) : null}
      {(
        <li className>
          { /* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a>
            Contests
            <ul className="sl-contest_nav__dropdown">
              <li>
                <a
                  href={`/${config.baseContestUrl(
                    allContests[period]['north-shore'].region,
                    allContests[period]['north-shore'].period,
                  )}`}
                >
                  {allContests[period]['north-shore'].name}
                </a>
              </li>
              {allContests[period].regional.map(contestRegion => (
                <li key={contestRegion.name}>
                  <a href={`/${config.baseContestUrl(contestRegion.region, contestRegion.period)}`}>
                    {contestRegion.name}
                  </a>
                </li>
              ))}
            </ul>
          </a>
        </li>
      )}
    </ul>
    {showLogo && _get(contest, 'meta.acf.logo', null) ? (
      <Link to={`/${config.baseContestUrl(region, period)}`}>
        <img
          src={contest.meta.acf.logo}
          alt={contest.post.post_title}
          className="sl-contest-nav__img"
        />
      </Link>
    ) : null}
  </div>
);

ContestNav.propTypes = {
  contest: contestPropType.isRequired,
  period: PropTypes.string.isRequired,
  region: PropTypes.string.isRequired,
  showLogo: PropTypes.bool.isRequired,
};

export default ContestNav;
